import { render, staticRenderFns } from "./CompanyPay.vue?vue&type=template&id=3f40a720&scoped=true"
import script from "./CompanyPay.vue?vue&type=script&lang=js"
export * from "./CompanyPay.vue?vue&type=script&lang=js"
import style0 from "./CompanyPay.vue?vue&type=style&index=0&id=3f40a720&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f40a720",
  null
  
)

export default component.exports